export default "__VITE_PUBLIC_ASSET__2b3d3ecd__"